{
  "register-secret-data-page": {
    "buttons": {
      "back": "Quay lại",
      "submit": "Xác nhận"
    },
    "text": {
      "login-data": "Thông tin đăng nhập của bạn",
      "login-data-hint": "Bạn cần thiết lập thông tin đăng nhập của mình"
    }
  }
}
